import { Button, ButtonProps } from "@avenue-8/sidekick-ui";
import { GoogleIcon } from "@assets/icons/GoogleIcon";
import { getApiRootUrl } from "@shared/utils/api-root-url";
import { INDIVIDUAL_PLAN_ID } from "@shared/utils/constants";
import { storeSsoLoginRedirect } from "@shared/utils/sso-login-redirect";

const SSO_BASE_URL = getApiRootUrl();

type Props = {
  flow: "login" | "subscription";
  buttonText: string;
  variant?: ButtonProps["variant"];
  fullWidth?: boolean;
  redirect?: string | null;
};

export const GoogleSsoButton = ({
  flow,
  buttonText,
  variant,
  fullWidth,
  redirect,
}: Props) => {
  const ssoUrl =
    flow === "login"
      ? `${SSO_BASE_URL}/auth/login/sso/start?provider=google`
      : `${SSO_BASE_URL}/auth/login/sso/${INDIVIDUAL_PLAN_ID}/start?flow=${flow}&provider=google&debug=false`;

  const handleClick = () => {
    if (flow === "subscription") {
      localStorage.setItem("@sidekick:registration-start-pending", "true");
      return;
    }
    storeSsoLoginRedirect(redirect ?? null);
  };

  return (
    <Button
      variant={variant}
      fullWidth={fullWidth}
      href={ssoUrl}
      onClick={handleClick}
      startIcon={<GoogleIcon />}
    >
      {buttonText}
    </Button>
  );
};
